import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { fetchOrderHistory } from 'src/app/state/actions/order';
import { getBFFOrdersActive, getBFFOrdersCompleted, getIsFetchingBFFOrders } from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import { OrderHistoryPage as Renderer } from '.';

const mapStateToProps = createStructuredSelector({
  isFetching: getIsFetchingBFFOrders,
  ordersActive: getBFFOrdersActive,
  ordersCompleted: getBFFOrdersCompleted,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    dispatchGetOrderHistory: () => dispatch(fetchOrderHistory()),
  };
};

export const OrderHistory = connect(mapStateToProps, mapDispatchToProps)(Renderer);
